import _ from 'lodash';
export var isVideoOverlayOpened = function (state) {
    return _.get(state, 'fullScreenModal.lightbox');
};
